import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { reduxForm, Field, formValueSelector } from 'redux-form';

import Content from '../../common/template/content';
import ContentCard from '../../common/template/contentCard';
import ContentCardHeader from '../../common/template/contentCardHeader';
import ContentCardBody from '../../common/template/contentCardBody';
import Row from '../../common/layout/row';
import Grid from '../../common/layout/grid';
import Table from '../../common/table/table';
import THead from '../../common/table/tHead';
import Tr from '../../common/table/tr';
import Th from '../../common/table/th';
import TBody from '../../common/table/tBody';
import Td from '../../common/table/td';
import ButtonTable from '../../common/table/buttonTable';
import Button from '../../common/button/button';
import Form from './safraManejoForm';
import imagemSoLogo from '../../assets/images/sologo.png';
import FormatUtils from '../../common/formatUtils/FormatUtils';
import DateFormat from '../../common/dateFormat/DateFormat';

import {
	setModoTela, initForm, salvar, excluir, getLista, getListaTipo,
	 getListaTipoProduto, getListaProduto, getListaPraga, getListaPlantaInvasora,
	 getListaDoenca, getListaUnidadeMedida, getListaFormaAplicacao

} from './safraManejoActions';

class SafraManejo extends Component {

	state = {
		linhaSelecionada: null
	}

    componentWillMount() {
        this.props.getLista(this.props.registroSafra.id);
		this.props.setModoTela('lista');
		this.props.getListaTipo();
		this.props.getListaTipoProduto();
		this.props.getListaProduto();
		this.props.getListaPraga();
		this.props.getListaPlantaInvasora();
		this.props.getListaDoenca();
		this.props.getListaUnidadeMedida();
		this.props.getListaFormaAplicacao();
    }

    render() {
        return (
            <div>

				{this.props.aguardando ? (
					<div class='modal fade show' id='modal-overlay' style={{ display: 'block', paddingRight: 15 }} aria-modal='true' role='dialog'>
						<div class='modal-dialog'>
							<div class='overlay'>
								<div style={{ marginLeft: '50%', marginRight: '50%' }}>
									<img src={imagemSoLogo} style={{ height: 40, width: 40, marginBottom: -76, marginLeft: 8 }} />
								</div>
								<i class='fas fa-4x fa-spinner fa-spin' style={{ marginLeft: '50%', marginRight: '50%' }}></i>
							</div>
						</div>
					</div>
				) : null}

                <Content>
					{this.props.modoTela == 'cadastro' ? (
						<Form onSubmit={this.props.salvar} />
					) : null}
					{this.props.modoTela == 'exclusao' ? (
						<Form excluir onSubmit={this.props.excluir} />
					) : null}
					{this.props.modoTela == 'lista' ? this.lista() : null}
                </Content>
            </div>
        )
    }

	lista() {
		return (
			<ContentCard>
				<ContentCardHeader>
					<label>Manejo</label>
				</ContentCardHeader>
				<ContentCardHeader>
					<Row>
						<Grid cols='6 6 4 2'>
							<Button
								text='Adicionar'
								type={'success'}
								icon={'fa fa-plus'}
								event={() => {
									this.props.setModoTela('cadastro', { id_safra: this.props.registroSafra.id });
									this.props.initForm({ id_safra: this.props.registroSafra.id });
								}} />
						</Grid>
					</Row>
				</ContentCardHeader>
				<ContentCardBody>
					<Table responsive>
						<THead>
							<Tr>
								<Th>Tipos de Produto</Th>
								<Th>Descrição</Th>
								<Th alignCenter>Data</Th>
								<Th alignRight>Área (hectare)</Th>
								<Th></Th>
							</Tr>
						</THead>
						<TBody>
							{this.props.lista.map(item => (
								<Tr key={item.id} className={`${this.state.linhaSelecionada == item.id ? 'hover' : ''}`}
									onClick={() => this.setState({ ...this.state, linhaSelecionada: item.id })}
									onMouseEnter={() => this.setState({ ...this.state, linhaSelecionada: item.id })} >
									<Td>{item.descricao_tipos}</Td>
									<Td>{item.descricao}</Td>
									<Td alignCenter>{DateFormat.formatarDataSqlParaTela(item.data_aplicacao)}</Td>
									<Td alignRight>{FormatUtils.formatarValorTela(item.area, 2)}</Td>
									<Td alignRight minWidth={100}>
										<ButtonTable
											type={'warning'}
											icon={'fas fa-pencil-alt'}
											visible={this.state.linhaSelecionada == item.id}
											event={() => {
												this.props.setModoTela('cadastro', {
													...item,
													area: FormatUtils.formatarValorTela(item.area, 2),
													densidade: FormatUtils.formatarValorTela(item.densidade, 2),
													populacao: FormatUtils.formatarValorTela(item.populacao, 0),
													espacamento: FormatUtils.formatarValorTela(item.espacamento, 2)
												});
												this.props.initForm({
													...item,
													area: FormatUtils.formatarValorTela(item.area, 2),
													densidade: FormatUtils.formatarValorTela(item.densidade, 2),
													populacao: FormatUtils.formatarValorTela(item.populacao, 0),
													espacamento: FormatUtils.formatarValorTela(item.espacamento, 2)
												});
											}} />

										<ButtonTable
											type={'danger'}
											icon={'fas fa-trash-alt'}
											visible={this.state.linhaSelecionada == item.id}
											event={() => {
												this.props.setModoTela('exclusao', {
													...item,
													area: FormatUtils.formatarValorTela(item.area, 2),
													densidade: FormatUtils.formatarValorTela(item.densidade, 2),
													populacao: FormatUtils.formatarValorTela(item.populacao, 0),
													espacamento: FormatUtils.formatarValorTela(item.espacamento, 2)
												});
												this.props.initForm({
													...item,
													area: FormatUtils.formatarValorTela(item.area, 2),
													densidade: FormatUtils.formatarValorTela(item.densidade, 2),
													populacao: FormatUtils.formatarValorTela(item.populacao, 0),
													espacamento: FormatUtils.formatarValorTela(item.espacamento, 2)
												});
											}} />
									</Td>
								</Tr>
							))}
						</TBody>
					</Table>
				</ContentCardBody>
			</ContentCard>
		);
	}


}

const mapStateToProps = state => ({
	sessao: state.auth.usuario,
	modoTela: state.safraManejo.modoTela,
	lista: state.safraManejo.lista,
	aguardando: state.safraManejo.aguardando,
	registroSafra: state.safra.registro
});
const mapDispatchToProps = dispatch => bindActionCreators({
	setModoTela, initForm, salvar, excluir, getLista, getListaTipo, getListaTipoProduto, getListaProduto, getListaPraga, getListaPlantaInvasora, getListaDoenca, getListaUnidadeMedida, getListaFormaAplicacao
}, dispatch);
export default connect(mapStateToProps, mapDispatchToProps)(SafraManejo);
